// extracted by mini-css-extract-plugin
module.exports = {"ratioField":"SocialSecurityContributionSection__ratioField--3yrcb"};